import { Button } from '@mm/components';
import { QuestionCircleIcon } from '@mm/icons';
import { useViewActions } from '@mm/state/actions/viewActions';
import classNames from 'classnames';
import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import './HelpWidget.pcss';
import { useSelector } from 'react-redux';
import { selectIsShopifyContext } from '@mm/state/selectors/viewSelectors';
import { QuestionOutlined } from '@ant-design/icons';
import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';

type Props = {
  className?: string;
};

export const HelpWidget = ({ className }: Props) => {
  const isShopify = useSelector(selectIsShopifyContext);
  const isWhitelabelCompany = useWhitelabelConfig();

  const { showSlideoutMenu } = useViewActions();

  const onHelpClick = () => {
    showSlideoutMenu('contactUsForm');
  };

  if (isShopify || isWhitelabelCompany) {
    return <></>;
  }

  return (
    <div className={classNames(className, 'help-widget')}>
      <CSSTransitionGroup
        transitionName={{
          enter: 'help-widget__appear',
          enterActive: 'help-widget__appear-active',
          appear: 'help-widget__appear',
          appearActive: 'help-widget__appear-active',
        }}
        transitionAppear={false}
        transitionEnter={false}
        transitionEnterTimeout={1000}
        transitionLeave={false}
      >
        <Button
          color="dark-gray"
          css={{ container: 'help-widget__button' }}
          onClick={() => onHelpClick()}
        >
          <QuestionOutlined className="help-widget__button-icon" />
          Help Center
        </Button>
      </CSSTransitionGroup>
    </div>
  );
};
